module.exports = __webpack_public_path__ + "img/3.4921d956.svg";